import { ThemeUICSSObject, spacing } from '@apia/theme';
/* IMPORT HERE */

const taskResult: ThemeUICSSObject = {
  maxWidth: 'root',
  margin: 'auto',
  mt: spacing(6),
  display: 'flex',
  flexDirection: 'column',
  gap: spacing(6),
  alignItems: 'center',
  justifyContent: 'center',

  '.notification': {
    width: '100%',
    flexShrink: 0,
  },
  /* PREPEND HERE */
};

export default taskResult;
